// Shared department-report media attachment constraints.
// These mirror the API's MediaStorageConstants (max size + allowed mime types);
// keep them in sync with app/Support/Constants/MediaStorageConstants.php.

export const MAX_ATTACHMENT_SIZE_BYTES = 10 * 1024 * 1024;

export const ACCEPTED_ATTACHMENT_TYPES = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "image/jpeg",
  "image/png",
  "image/webp",
];

export const ACCEPTED_ATTACHMENT_EXTENSIONS =
  ".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.webp";

const ACCEPTED_EXTENSION_PATTERN = /\.(pdf|docx?|xlsx?|jpe?g|png|webp)$/i;

export function formatFileSize(sizeBytes?: number | null): string {
  if (!sizeBytes || sizeBytes <= 0) return "Unknown size";
  if (sizeBytes < 1024) return `${sizeBytes} B`;
  if (sizeBytes < 1024 * 1024) return `${(sizeBytes / 1024).toFixed(1)} KB`;
  return `${(sizeBytes / (1024 * 1024)).toFixed(1)} MB`;
}

/**
 * Validates a selected file against the accepted types and size limit.
 * Returns a human-readable error message, or null when the file is acceptable.
 */
export function validateAttachment(file: File): string | null {
  const hasAcceptedType = ACCEPTED_ATTACHMENT_TYPES.includes(file.type);
  const hasAcceptedExtension = ACCEPTED_EXTENSION_PATTERN.test(file.name);

  if (!hasAcceptedType && !hasAcceptedExtension) {
    return `${file.name} is not an accepted file type.`;
  }
  if (file.size > MAX_ATTACHMENT_SIZE_BYTES) {
    return `${file.name} is larger than 10 MB.`;
  }
  return null;
}
